module.exports = __webpack_public_path__ + "img/afrilex.2ad510bf.png";